export const generateLocationName = (location) => {
    if(location.types[0] === 'postal_code' && location.terms[2]) {
        return `${location.terms[2].value} (${location.terms[0].value}, ${location.terms[1].value})`;
    } else if(location.types[0] === 'locality') {
        return `${location.terms[0].value}, ${location.terms[1].value}`;
    } else {
        return location.description;
    }
};
